/*
  Recently Browsed — new code (paired with sections/recently-browsed.liquid).
  Foundation: ProductRecommendations custom element (global.js) — same
  IntersectionObserver lazy trigger, same fetch-and-swap of this section's
  own markup via the Section Rendering API. Only the data source differs:
  product ids come from localStorage (written by
  snippets/recently-browsed-tracker.liquid) and the fetch goes to the search
  URL with q=id:X OR id:Y instead of the recommendations endpoint.
  slider-component in the injected markup self-initializes, as it does for
  Related Products.
*/
class RecentlyBrowsed extends HTMLElement {
  static STORAGE_KEY = 'gb-recently-browsed';

  connectedCallback() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadProducts();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  readList() {
    try {
      const list = JSON.parse(localStorage.getItem(RecentlyBrowsed.STORAGE_KEY));
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  loadProducts() {
    const limit = parseInt(this.dataset.limit, 10) || 4;
    const currentId = this.dataset.currentProductId;
    const items = this.readList()
      .filter((item) => item && item.id && String(item.id) !== currentId)
      .slice(0, limit);

    if (!items.length) return;

    const query = items.map((item) => `id:${item.id}`).join(' OR ');

    fetch(`${this.dataset.url}&q=${encodeURIComponent(query)}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const source = html.querySelector('recently-browsed');

        if (!source || !source.innerHTML.trim().length) return;
        if (!source.querySelector('.grid__item')) return;

        // Search returns relevance order; restore "last browsed first"
        // using the handle stored alongside each id.
        const grid = source.querySelector('ul.product-grid');
        if (grid) {
          const order = items.map((item) => item.handle);
          const position = (slide) => {
            const link = slide.querySelector('a[href*="/products/"]');
            if (!link) return order.length;
            const handle = link
              .getAttribute('href')
              .split('?')[0]
              .split('/products/')
              .pop()
              .split('/')[0];
            const index = order.indexOf(handle);
            return index === -1 ? order.length : index;
          };
          Array.from(grid.children)
            .sort((a, b) => position(a) - position(b))
            .forEach((slide) => grid.appendChild(slide));
        }

        this.innerHTML = source.innerHTML;
        this.removeAttribute('hidden');
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('recently-browsed', RecentlyBrowsed);
